import { createSelector } from 'reselect';

import IState from 'types/Istore';

import { selectUserTrackingInfo } from './otherSelectors';

const selectOccupation = (state: IState) => state.rekycVerification.occupation;

const selectAnnualIncome = (state: IState) => state.rekycVerification.annualIncome;

const selectPoliticallyExposed = (state: IState) =>
  state.rekycVerification.politicallyExposed;

const selectKycDetails = (state: IState) => state.rekycVerification.detailsData;

const selectRekycFlowApiData = (state: IState) => state.rekycVerification.rekycFlow;

const selectIsRekycModalOpen = (state: IState) =>
  state.rekycVerification.verificationModalOpen;

const selectRekycInfoPendingModal = (state: IState) =>
  state.rekycVerification.restrictionsInfoModalOpen;

// giving
const selectFinalRekycFlow = createSelector(
  [selectUserTrackingInfo, selectRekycFlowApiData],
  (trackingInfo, apiData) => {
    return trackingInfo?.rekyc_flow || apiData.data;
  }
);

const selectRekycModalOpenSource = (state: IState) =>
  state.rekycVerification.modalOpenSource;

export {
  selectOccupation,
  selectAnnualIncome,
  selectPoliticallyExposed,
  selectKycDetails,
  selectRekycFlowApiData,
  selectIsRekycModalOpen,
  selectRekycInfoPendingModal,
  selectFinalRekycFlow,
  selectRekycModalOpenSource,
};
